<template>
    <div class="app-wrapper">
        <core-notification/>
        <core-header v-if="!!auth.auth"/>
        <core-view/>
        <core-footer/>
        <div class="full-screen-btn" @click="toggle">
            <img v-if="!fullscreen" :src="require('./assets/expand_icon.svg')" alt="expand">
            <img v-if="fullscreen" :src="require('./assets/exit_fullscreen.svg')" alt="exit full screen">
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {getAuthUser}          from "@/api/auth";

export default {
    name:       'App',
    data:       () => {
        return {
            fullscreen: false
        }
    },
    components: {
        CoreHeader:       () => import('./components/core/Header'),
        CoreFooter:       () => import('./components/core/Footer'),
        CoreView:         () => import('./components/core/View'),
        CoreNotification: () => import('./components/core/Notification'),
    },
    computed:   {
        ...mapState(['auth', 'userLocations']),
        ...mapActions(['setLimitOrders'])
    },
    created() {
        if (window.localStorage.getItem('ACCESS_TOKEN')) {
            getAuthUser()
                .then(res => {
                    this.$store.dispatch('setAuth', res.data);
                    this.$store.dispatch('setLocations', res.data.locations);
                });
        }
    },
    methods: {
        async toggle() {
            await this.$fullscreen.toggle()
            this.fullscreen = !this.$fullscreen.isFullscreen
        },
    },
    async mounted() {
        if (this.$router.currentRoute.name !== 'login') {
            await this.setLimitOrders;
        }
    },
}
</script>
<style>
/* nunito-regular - cyrillic-ext_cyrillic */
@font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    src: url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
    url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-regular.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-regular.woff') format('woff'), /* Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-regular.ttf') format('truetype'); /* Safari, Android, iOS */
}

/* nunito-700 - cyrillic-ext_cyrillic */
@font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    src: url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-700.eot'); /* IE9 Compat Modes */
    src: local(''),
    url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-700.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-700.woff') format('woff'), /* Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-700.ttf') format('truetype'); /* Legacy iOS */
}

/* nunito-800 - cyrillic-ext_cyrillic */
@font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 800;
    src: url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-800.eot'); /* IE9 Compat Modes */
    src: local(''),
    url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-800.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-800.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-800.woff') format('woff'), /* Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-800.ttf') format('truetype'); /* Legacy iOS */
}

/* nunito-900 - cyrillic-ext_cyrillic */
@font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 900;
    src: url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-900.eot'); /* IE9 Compat Modes */
    src: local(''),
    url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-900.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-900.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-900.woff') format('woff'), /* Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-900.ttf') format('truetype'); /* Legacy iOS */
}

/* nunito-italic - cyrillic-ext_cyrillic */
@font-face {
    font-family: 'Nunito';
    font-style: italic;
    font-weight: 400;
    src: url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-italic.eot'); /* IE9 Compat Modes */
    src: local(''),
    url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-italic.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-italic.woff') format('woff'), /* Modern Browsers */ url('./assets/fonts/nunito-v25-cyrillic-ext_cyrillic-italic.ttf') format('truetype'); /* Legacy iOS */
}

/* nunito-italic - cyrillic-ext_cyrillic */
@font-face {
    font-family: 'Lufga';
    src: url('./assets/fonts/Lufga-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

body, html {
    font-family: 'Nunito', sans-serif !important;
}

.full-screen-btn {
    position: absolute;
    right: 3%;
    top: 10%;
    border: 1px solid #ec665a;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
}

.full-screen-btn img {
    width: 30px;
}

.app-wrapper {
    background: #ffffff;
}

</style>
